/// <reference path="../../adpIntegration/sections/adpIntegration.workActivities.section.ts" />

module Meevo.Plugins.AdpWfnIntegration {
    "use strict";

    /**
    * Main Section of Field Labels
    */
    export class WfnWorkActivitiesSection extends Meevo.Plugins.AdpIntegration.WorkActivitiesSection {

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            modalService: Meevo.Components.Modal.IModalService,
            sectionSecurityKey?: string
        ) {
            super(sectionId,
                displayNameContentKey,
                template,
                isPrimarySection,
                handlesOwnCrud,
                baseEndpoint,
                sectionEndpoint,
                loggingService,
                dataService,
                noun,
                identityService,
                modalService,
                sectionSecurityKey)
        }
    }
}